import { defineComponent as _defineComponent } from 'vue'
interface Props {
  items?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFaq',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})